import { useTranslation } from "react-i18next"

const BillSection = ({ data }) => {
    const { t } = useTranslation()
    return (
        <div className="bill-summary p-3">
            <h4 className="fw-bold mb-4 text-right ">{t("bill-info")}</h4>
            <div className="row">
                <div className="text-center col-4">
                    <div className="text-gray-600 fw-bolder mb-3">{t("serviceFeesRequestBill")}</div>
                    <div className="fw-bold">{data.serviceFees}</div>
                </div>
                <div className="text-center col-4">
                    <div className="text-gray-600 fw-bolder mb-3">{t("patientFees")}</div>
                    <div className="fw-bold">{data.patientFees}</div>
                </div>
                <div className="text-center col-4">
                    <div className="text-gray-600 fw-bolder mb-3">{t("totalRequestBill")}</div>
                    <div className="fw-bold">
                        {Number(data.serviceFees) + Number(data.patientFees)} {t("pound")}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BillSection